export default class Chart {
  constructor() {
    console.log('Chart class loaded');
  }

  static getDateForResolution(date: string, resolution: string, options: any = {}) {
    const xDate = new Date(date);
    const { separator = ' ', resolutionOverride = '', formatOverride = '' } = options;

    let dateString;

    if (formatOverride) {
      return formatOverride.split(/(?:\n|<br>|\\n)/).map((format: string) => xDate.format(format)).join(separator);
    }

    switch (resolutionOverride || resolution) {
      case 'hour':
        dateString = xDate.format('H:i') + separator + xDate.format('d.m.Y');
        break;
      case 'day':
        dateString = xDate.format('d.m.Y');
        break;
      case 'week':
        dateString = `KW ${xDate.format('W Y')}`;
        break;
      case 'month':
        dateString = xDate.format('F Y');
        break;
      case 'year':
        dateString = xDate.format('Y');
        break;
      default:
        dateString = xDate.format('d. F Y');
    }

    return dateString;
  }

  static dateDiff(date1: Date, date2: Date, count = 'days') {
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const diffWeeks = Math.ceil(diffDays / 7);
    const diffMonths = (date2.getFullYear() - date1.getFullYear()) * 12 + (date2.getMonth() - date1.getMonth());
    const diffYears = date2.getFullYear() - date1.getFullYear();

    switch (count) {
      case 'days':
        return diffDays;
      case 'weeks':
        return diffWeeks;
      case 'months':
        return diffMonths;
      case 'years':
        return diffYears;
      default:
        throw new Error('Invalid count parameter');
    }
  }

  static canHideData(event: Highcharts.SeriesLegendItemClickEventObject, enableHiding: boolean = true): boolean {
    if (!enableHiding) {
      return false;
    }

    const { chart } = event.target;
    const visibleSeriesCount = chart.series.filter((series) => series.visible).length;

    if (visibleSeriesCount === 1 && event.target.visible) {
      return false;
    }

    return true;
  }

  static generateData(type: string, maxValue: number = 100): Array<[number, number]> {
    const now = new Date();
    const timestamps: Array<[number, number]> = [];
    let currentTimestamp = now.getTime();

    const addTime = (ms: number) => {
      currentTimestamp += ms;
      timestamps.push([currentTimestamp, Math.floor(Math.random() * maxValue) + 1]);
    };

    switch (type) {
      case 'hour':
        for (let i = 0; i < 24 * 4; i += 1) {
          // 24 hours, each with 4 intervals of 15 minutes
          addTime(15 * 60 * 1000); // 15 minutes in milliseconds
        }
        break;
      case 'day':
        for (let i = 0; i < 30; i += 1) {
          // 30 days
          addTime(24 * 60 * 60 * 1000); // 1 day in milliseconds
        }
        break;
      case 'week':
        for (let i = 0; i < 52; i += 1) {
          // 52 weeks
          addTime(7 * 24 * 60 * 60 * 1000); // 1 week in milliseconds
        }
        break;
      case 'month':
        for (let i = 0; i < 12; i += 1) {
          // 12 months
          const nextMonth = new Date(now.getFullYear(), now.getMonth() + i + 1, 1);
          addTime(nextMonth.getTime() - currentTimestamp);
        }
        break;
      case 'year':
        for (let i = 0; i < 10; i += 1) {
          // 10 years
          const nextYear = new Date(now.getFullYear() + i + 1, 0, 1);
          addTime(nextYear.getTime() - currentTimestamp);
        }
        break;
      default:
        break;
    }

    return timestamps;
  }
}
